import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import memoize from 'lodash.memoize';
import { Grid } from '@mui/material';
import { Button, Dialog } from '@totalsoft/rocket-ui';
import OfferPartnerConsentItem from './OfferPartnerConsentItem';
import { Prompt } from 'react-router-dom';
import { withRights } from 'providers/RightsConsumer';
import { BoxActionsWrapper, GridActionsWrapper } from 'components/common/CommonStyles';
import ThinDivider from 'components/common/ThinDivider';

class OfferPartnerConsent extends React.PureComponent {
  state = {
    openParticipantsConfirmation: false
  };

  handlePropertyChange = memoize(index => (prop, value) => {
    this.props.handleChange(index, prop, value);
  });

  handleUpload = memoize(index => (...rest) => {
    this.props.handleUpload(index, ...rest);
  });

  handleParticipantsConfirmationPositive = () => {
    this.props.goToSigning();
    this.setState({ openParticipantsConfirmation: false });
  };

  handleParticipantsConfirmationClose = () => {
    this.setState({ openParticipantsConfirmation: false });
  };

  onGoToSigning = () => {
    this.setState({ openParticipantsConfirmation: true });
  };

  render() {
    const { openParticipantsConfirmation } = this.state;
    const { t, consents, loading, handleDownload, onSubmit, onPrint, rights, consentInfoIsDirty } = this.props;

    return (
      <Grid container spacing={1}>
        <Prompt when={consentInfoIsDirty} message={t('LeavingWithoutSaving')} />
        {consents.map((consent, index) => {
          return (
            <Grid key={index} item xs={12}>
              <OfferPartnerConsentItem
                item={consent}
                handleChange={this.handlePropertyChange(index)}
                handleUpload={this.handleUpload(index)}
                handleDownload={handleDownload}
                idx={index}
              />
              <ThinDivider mt={1} />
            </Grid>
          );
        })}
        {!rights.isImage && (
          <>
            <GridActionsWrapper mt={2} item xs={12}>
              <Button
                id={'offerPartnerConsentCard_signBtn'}
                color='primary'
                variant='contained'
                onClick={this.onGoToSigning}
                disabled={
                  rights.readOnlyFull ||
                  loading.form ||
                  !consents.some(x => x.selected) ||
                  consentInfoIsDirty ||
                  !rights.clientConsentsWrite
                }
              >
                {t('OfferEdit.Client.Consent.GoToSigning')}
              </Button>
              <Button
                id={'offerPartnerConsentCard_printBtn'}
                color='primary'
                variant='contained'
                onClick={onPrint}
                disabled={rights.readOnlyFull || loading.print || !rights.clientConsentsWrite}
              >
                {loading.print ? t('Printing') : t('Print')}
              </Button>
              <Button
                id={'offerPartnerConsentCard_saveBtn'}
                color='primary'
                variant='contained'
                onClick={onSubmit}
                disabled={rights.readOnlyFull || loading.form || !rights.clientConsentsWrite || !consentInfoIsDirty}
              >
                {loading.form ? t('Saving') : t('Save')}
              </Button>
            </GridActionsWrapper>
          </>
        )}

        <Dialog
          open={openParticipantsConfirmation}
          onClose={this.handleParticipantsConfirmationClose}
          aria-labelledby='participantsConfirmation-title'
          aria-describedby='participantsConfirmation-description'
          content={t('OfferEdit.Client.Consent.Dialog.Description')}
          actions={
            <BoxActionsWrapper forDialog>
              <Button
                id={'offerPartnerConsentCard_acceptButton'}
                color='primary'
                autoFocus
                onClick={this.handleParticipantsConfirmationPositive}
              >
                {t('OfferEdit.Client.Consent.Dialog.AcceptButton')}
              </Button>
              <Button id={'offerPartnerConsentCard_rejectButton'} color='primary' onClick={this.handleParticipantsConfirmationClose}>
                {t('OfferEdit.Client.Consent.Dialog.RejectButton')}
              </Button>
            </BoxActionsWrapper>
          }
        />
      </Grid>
    );
  }
}

OfferPartnerConsent.propTypes = {
  t: PropTypes.func.isRequired,
  consents: PropTypes.array.isRequired,
  loading: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onPrint: PropTypes.func.isRequired,
  goToSigning: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleUpload: PropTypes.func.isRequired,
  handleDownload: PropTypes.func.isRequired,
  rights: PropTypes.object.isRequired,
  consentInfoIsDirty: PropTypes.bool.isRequired
};

export default withTranslation()(withRights(OfferPartnerConsent));
